import { render, staticRenderFns } from "./FourthAnniversary.vue?vue&type=template&id=ff058328&"
import script from "./FourthAnniversary.vue?vue&type=script&lang=js&"
export * from "./FourthAnniversary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports